// ═══════════════════════════════════════════════════════════════════════════════
// Settlement Validation Schemas
// ═══════════════════════════════════════════════════════════════════════════════
import { z } from 'zod';
import { SETTLEMENT_STATUS, SUPPORTED_LANGUAGES } from '../constants/index.js';
import { uuidSchema } from './common.schema.js';
// ── Create Settlement Input Schema ──
export const createSettlementInputSchema = z.object({
    mainBudgetId: uuidSchema,
    /** Required in API when locking with zero receipts in range (client confirms after prompt). */
    acknowledgeNoReceipts: z.boolean().optional(),
});
// ── Unlock Settlement Input Schema ──
export const unlockSettlementInputSchema = z.object({
    settlementId: uuidSchema,
});
// ── Settlement ID Param Schema ──
export const settlementIdParamSchema = z.object({
    id: uuidSchema,
});
// ── Settlement by budget param (employer) ──
export const settlementByBudgetParamSchema = z.object({
    budgetId: uuidSchema,
});
// ── Settlement Query Schema ──
export const settlementQuerySchema = z.object({
    budgetId: uuidSchema.optional(),
    locked: z.enum(['true', 'false', 'all']).default('all'),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(20),
});
export const settlementViewerQuerySchema = z.object({
    viewerLanguage: z.enum(SUPPORTED_LANGUAGES).optional(),
});
export const reviewSettlementInputSchema = z.object({
    status: z.enum([SETTLEMENT_STATUS.REJECTED, SETTLEMENT_STATUS.REVIEWED]),
    rejectedReason: z.string().max(500).optional().default(''),
});
//# sourceMappingURL=settlement.schema.js.map